import React from 'react';
import {Button} from "semantic-ui-react";
import { injectIntl } from 'react-intl';
import PropTypes from 'prop-types';

import CustomModal from "../CustomModal/CustomModal";


class ErrorMessage extends React.PureComponent {

  constructor(props) {
    super(props);
    this.state = {
      openModel: false
    }
  }

static propTypes = {
  showError: PropTypes.bool,
  automationIdPrefix: PropTypes.string
}

  componentDidUpdate(prevProps) {
    if (this.props.showError && this.props.showError !== prevProps.showError) {
      this.setState({
        openModel: this.props.showError
      });
    }
  }

  render() {

    const { intl } = this.props;
    const { formatMessage } = intl;

    return (<React.Fragment>
      <CustomModal
        open={this.state.openModel}
        className={'como-dialog settings-dialog'}
        onClose={() => {this.setState({openModel: false});}}
        automationIdPrefix={this.props.automationIdPrefix}
        header={
          <div className="type-and-name">
            {this.props.errorTitle}
          </div>
        }
        content={
          <div className="purchase-item-detail">
            {this.props.errorMessage || ''}
          </div>
        }
        actions={[
          <Button
            key="cancel"
            data-automation-id={`${this.props.automationIdPrefix}.cancel`}
            onClick={() => {this.setState({openModel: false});}}
          >
            { formatMessage({id: 'general.button.cancel'}) }
          </Button>
        ]}
        closeOnDimmerClick
      />
    </React.Fragment>)
  }
}

export default injectIntl(ErrorMessage);
